<template>
  <div class="arrow-box" v-if="scrolled">
    <a class="button" @click="scrollTop">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </a>
  </div>
</template>
<script>
export default {
  name: 'arrowUp',
  data() {
    return {
      scrolled: false
    };
  },
  methods: {
    scrollTop() {
      const body = $("html, body");
      body.stop().animate({ scrollTop: 0 }, 500, 'swing');
    },
    handleScroll() {
      this.scrolled = window.scrollY > 200;
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="scss">
.arrow-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
  a {
    background: #f3ab3c;
    border: none;
    font-size: 1.4em;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/arrowUp.vue